export function GetAACode(frontColor: string, templeColor: string, temple: string): string | null {
	const combination = ACETANIUM_COMBINATIONS.find(x => x.color == [frontColor, templeColor].join('-') && x.temple == temple)
	return combination ? combination.code : null
}

export const ACETANIUM_COMBINATIONS = [
	['AA36', 'K15-10', '01'],
	['AA37', 'K20-10', '01'],
	['AA38', 'K24-10', '01'],
	['AA39', 'K23-113', '01'],
	['AA40', 'K02-P10', '01'],
	['AA42', 'K13-P10', '21'],
	['AA43', 'K16-P10', '01'],
	['AA44', 'K22-P11', '01'],
	['AA45', 'K19-P11', '01'],
	['AA46', 'K17-P25', '01'],
	['AA47', 'K18-P60', '01'],
	['AA48', 'K02-P70', '01'],
	['AA49', 'K14-P70', '01'],
	['AA50', 'K02-10', '01'],
	['AA51', 'K08-10', 'BASIC'],
	['AA52', 'K24-10', 'BASIC'],
	['AA53', 'K23-P10', 'BASIC'],
	['AA54', 'K15-P30', '01'],
	['AA55', 'K23-P11', '01'],
	['AA56', 'K24-P10', '01'],
	['AA57', 'M01-P10', '01'],
	['AA58', 'K36-P10', '13'],
	['AA59', 'K17-10', '01'],
	['AA60', 'K20-P10', '01'],
	['AA61', 'K25-10', '01'],
	['AA64', 'K19-P11', 'BASIC'],
	['AA67', 'K14-P10', '01'],
	['AA68', 'K36-P10', '01'],
	['AA69', 'K15-P10', '01'],
	['AA70', 'K25-P11', '01'],
	['AA71', 'M01-10', '01'],
	['AA72', 'M01-K24/P10', '13'],
	['AA73', 'K17-P10', '01'],
	['AA74', 'K24-M01/P10', '13'],
	['AA75', 'K01-10', '01'],
	['AA76', 'K29-K24/10', '13'],
	['AA77', 'K38-P10', '13'],
	['AA78', 'K25-10', '13'],
	['AA79', 'K37-P10', '01'],
	['AA80', 'K26-P10', '01'],
	['AA81', 'K39-10', '13'],
	['AA82', 'K26-P10', '13'],
	['AA83', 'M01-P10', '13'],
	['AA84', 'K59-P10', '21'],
	['AA85', 'K67-05', '01'],
	['AA86', 'K59-P10', '01'],
	['AA87', 'K59-U9', '01'],
	['AA88', 'K52-05', '01'],
	['AA89', 'K58-U14', '01'],
	['AA90', 'K68-05', '01'],
	['AA91', 'K16-60', '01'],
	['AA92', 'K15-30', '01'],
	['AA93', 'K42-K42/10', '90'],
	['AB01', 'K15-10', '22'],
	['AB02', 'K25-10', '219'],
	['AB03', 'K45-10', '22'],
	['AB04', 'M01-P10', '22'],
	['AB05', 'K44-P10', '14'],
	['AB06', 'K45-109', '14'],
	['AB07', 'K49-P60', '14'],
	['AB08', 'M01-P10', '14'],
	['AB09', 'K39-P10', '22'],
	['AB10', 'K45-109', '22'],
	['AB11', 'K47-P90', '22'],
	['AB12', 'K24-10', '21'],
	['AB13', 'K25-10', '21'],
	['AB14', 'K44-10', '21'],
	['AB15', 'K45-10', '21'],
	['AB16', 'K26-10', '21'],
	['AB17', 'K41-10', '21'],
	['AB18', 'K36-P10', '22'],
	['AB19', 'K38-P11', '22'],
	['AB20', 'K49-P10', '22'],
	['AB21', 'K37-10', '22'],
	['AB22', 'K45-P10', '22'],
	['AB23', 'M01-10', '22'],
	['AB24', 'K16-10', '22'],
	['AB25', 'K17-10', '22'],
	['AB26', 'K44-P10', '22'],
	['AB27', 'K47-P10', '22'],
	['AB28', 'K14-10', '22'],
	['AB29', 'K01-10', '22'],
	['AB30', 'K37-P10', '22'],
	['AB31', 'K17-P10', '22'],
	['AB32', 'K42-P11', '21'],
	['AB33', 'K44-P10', '01'],
	['AB34', 'K23-P10', '21'],
	['AB35', 'K58-107', '21'],
	['AB36', 'K58-107', '01'],
	['AB37', 'K58-10', '01'],
	['AB38', 'K58-P10', '07'],
	['AB39', 'M01-P10', '01'],
	['AB40', 'K02-60', '01'],
	['AB41', 'K28-P70', '01'],
	['AB42', 'K39-P10', '07'],
	['AB43', 'K14-113', '01'],
	['AB44', 'K17-113', '01'],
	['AB45', 'K17-P25', '01'],
	['AB46', 'K47-P85', '01'],
	['AB47', 'K25-P10', '01'],
	['AB48', 'K47-P10', '22'],
	['AB49', 'K16-P10', '01'],
	['AB50', 'K16-P10', '07'],
	['AB51', 'K45-P10', '01'],
	['AB52', 'M01-P10', '07'],
	['AB53', 'M01-P10', '01'],
	['AB54', 'K38-P11', '01'],
	['AB55', 'K41-U9', '22'],
	['AB56', 'K39-U9', '22'],
	['AB57', 'M01-P10', '01'],
	['AB58', 'K44-P10', '22'],
	['AB59', 'K44-P10', '21'],
	['AB60', 'K24-U9', '19'],
	['AB61', 'K08-U12', '19'],
	['AB62', 'K23-05', '19'],
	['AB63', 'K42-10', '19'],
	['AB64', 'K42-U9', '19'],
	['AB65', 'K23-U14', '19'],
	['AB66', 'K67-05', '22'],
	['AB67', 'K24-P10', '19'],
	['AB68', 'K24-P10', '207'],
	['AB69', 'M01-U9', '207'],
	['AB70', 'K64-U14', '207'],
	['AB71', 'K52-05', '207'],
	['AB72', 'K24-05', '207'],
	['AB73', 'K62-109', '207'],
	['AB74', 'K58-U9', '207'],
	['AB75', 'K37-109', '207'],
	['AB76', 'K25-U9', '207'],
	['AB77', 'K45-U9', '207'],
	['AB78', 'K62-109', '207'],
	['AB79', 'K37-10', '207'],
	['AC01', 'K60-77', '22'],
	['AC02', 'K60-25', '17'],
	['AC03', 'K60-10', '01'],
	['AC04', 'K61-P10', '01'],
	['AC05', 'K62-109', '22'],
	['AC06', 'K62-P10', '17'],
	['AC07', 'K62-P30', '21'],
	['AC08', 'K62-109', '01'],
	['AC09', 'K63-20', '01'],
	['AC10', 'K64-P60', '18'],
	['AC11', 'M01-10', '01'],
	['AC12', 'K66-P10', '22'],
	['AC13', 'K67-P10', '21'],
	['AC14', 'K67-05', '22'],
	['AC15', 'K68-P30', '17'],
	['AC16', 'M01-05', '18'],
	['AC17', 'K01-P10', '22'],
	['AC18', 'K08-U9', '21'],
	['AC19', 'K08-109', '22'],
	['AC20', 'K16-P60', '01'],
	['AC21', 'K23-K23/U9', '90'],
	['AC22', 'K23-113', '17'],
	['AC23', 'K23-P10', '01'],
	['AC24', 'K23-10', '22'],
	['AC25', 'K23-05', '22'],
	['AC26', 'K24-K24/U9', '90'],
	['AC27', 'K24-K24/U9', '91'],
	['AC28', 'K24-K24/P10', '90'],
	['AC29', 'K24-U9', '22'],
	['AC30', 'K25-K25/10', '91'],
	['AC31', 'K25-K25/U9', '90'],
	['AC32', 'K28-60', '18'],
	['AC33', 'K28-60', '01'],
	['AC34', 'K39-10', '22'],
	['AC35', 'K42-K42/10', '91'],
	['AC36', 'K42-K42/109', '90'],
	['AC37', 'K44-P10', '22'],
	['AC38', 'K45-K24/05', '91'],
	['AC39', 'K45-05', '01'],
	['AC40', 'K45-24/05', '90'],
	['AC41', 'K47-P10', '22'],
	['AC42', 'K52-P10', '01'],
	['AC43', 'K54-K54/P10', '90'],
	['AC44', 'K54-K54/P10', '91'],
	['AC45', 'K57-25', '18'],
	['AC46', 'K58-P10', '01'],
	['AC47', 'K52-117', '01'],
	['AC48', 'K64-P10', '22'],
	['AC49', 'K62-P10', '01'],
	['AC50', 'K62-10', '207'],
	['AC51', 'K62-10', '22'],
	['AC52', 'K42-10', '01'],
	['AC53', 'K60-05', '01'],
	['AC54', 'K67-P10', '01'],
	['AC55', 'K67-U12', '01'],
	['AC56', 'K76-P11', '01'],
	['AC57', 'K76-PGT', '01'],
	['AC58', 'K83-PU9', '01'],
	['AC59', 'K85-PGT', '01'],
	['AC60', 'K86-U14', '01'],
	['AC61', 'K93-PGT', '01'],
	['AC62', 'K41-U9', '21'],
	['AC63', 'K88-10', '21'],
	['AC64', 'K26-U9', '22'],
	['AC65', 'K88-10', '22'],
	['AC66', 'K59-P10', '17'],
	['AC67', 'K76-10', '17'],
	['AC68', 'K76-35', '17'],
	['AC69', 'K76-PGT', '17'],
	['AC70', 'K82-P60', '17'],
	['AC71', 'K87-P10', '17'],
	['AC72', 'K88-P60', '17'],
	['AC73', 'K41-PU9', '19'],
	['AC74', 'K42-10', '19'],
	['AC75', 'K62-10', '19'],
	['AC76', 'K87-P10', '19'],
	['AC77', 'K25-107', '207'],
	['AC78', 'K37-U12', '207'],
	['AC79', 'K59-10', '207'],
	['AC80', 'K76-10', '207'],
	['AC81', 'K87-PU9', '207'],
	['AC82', 'K67-77', '77'],
	['AC83', 'K83-35', '77'],
	['AC84', 'K85-PGT', '77'],
	['AC85', 'K08-K08/10', '94'],
	['AC86', 'K23-K23/05', '94'],
	['AC87', 'K24-K24/05', '94'],
	['AC88', 'K24-K24/P10', '94'],
	['AC89', 'K92-K92/PGT', '94'],
	['AC90', 'K92-K92/U14', '94'],
	['AC91', 'K38-K38/P10', '95'],
	['AC92', 'K82-K82/P60', '95'],
	['AC93', 'K86-K86/05', '95'],
	['AC94', 'K84-K24/P10', '94'],
	['AC95', 'K76-K76/P10', '94'],
	['AC96', 'K83-K24/05', '94'],
	['AC97', 'K37-K37/PGT', '94'],
	['AC98', 'K25-K25/U14', '94'],
	['AC99', 'K45-05', '17'],
	['AD01', 'K87-K87/10', '94'],
	['AD02', 'K95-05', '17'],
	['AD03', 'K97-K97/PGT', '94'],
	['AD04', 'K91-PGT', '17'],
	['AD05', 'K87-U14', '207'],
	['AD06', 'K24-U9', '207'],
	['AD07', 'K23-10', '207'],
	['AD08', 'K25-10', '207'],
	['AD09', 'K97-PU9', '207'],
	['AD10', 'K24-10', '207'],
	['AD11', 'K92-10', '207'],
	['AD12', 'K42-U9', '207'],
	['AD13', 'K25-U12', '21'],
	['AD14', 'K87-10', '21'],
	['AD15', 'K24-K24/P10', '91'],
	['AD16', 'K97-K97/U9', '91'],
	['AD17', 'K24-K24/10', '91'],
	['AD18', 'K97-K97/PU9', '91'],
	['AD19', 'K76-10', '21'],
	['AD20', 'K92-10', '21'],
	['AD21', 'K100-K101/10', '90'],
	['AD22', 'K92-10', '19'],
	['AD23', 'K105-U14', '19'],
	['AD24', 'K104-P10', '402'],
	['AD25', 'K95-P10', '401'],
	['AD26', 'K84-PU9', '402'],
	['AD27', 'K97-K97/U9', '94'],
	['AD28', 'K95-05', '401'],
	['AD29', 'K37-PGT', '401'],
	['AD30', 'K24-PU9', '401'],
	['AD31', 'K76-10', '401'],
	['AD32', 'K95-05', '207'],
	['AD33', 'K92-PU12', '207'],
	['AD34', 'K87-K87/PGT', '301'],
	['AD35', 'K52-05', '402'],
	['AD36', 'K88-PU12', '402'],
	['AD37', 'K105-PGT', '402'],
	['AD38', 'K108-05', '401'],
	['AD39', 'K76-K76/05', '94'],
	['AD40', 'K85-K85/60', '94'],
	['AD41', 'K83-K83/PGT', '94'],
	['AD42', 'M01-05', '22'],
	['AD43', 'K25-K25/10', '90'],
	['AD44', 'K105-10', '22'],
	['AD45', 'K24-K24/PU9', '90'],
	['AD47', 'K85-K85/PGT', '94'],
	['AD48', 'K24-K24/05', '94'],
	['AD49', 'K104-P10', '22'],
	['AD50', 'K97-U9', '22'],
	['AD51', 'K24-U9', '22'],
	['AD52', 'K83-K83/35', '302'],
	['AD53', 'K67-K67/77', '302'],
	['AD54', 'K107-K107/PGT', '302'],
	['AD55', 'K103-K103/PGT', '300'],
	['AD56', 'K82-K82/PGT', '300'],
	['AD57', 'K24-K24/P10', '300'],
	['AD58', 'M01-P10', '401'],
	['AD59', 'K118-U14', '401'],
	['AD60', 'K24-U9', '401'],
	['AD61', 'K108-05', '401'],
	['AD62', 'K45-05', '401'],
	['AD63', 'K118-113', '402'],
	['AD64', 'K119-PGT', '401'],
	['AD65', 'K119-K119/P10', '94'],
	['AD66', 'K84-U9', '17'],
	['AD67', 'K115-U14', '17'],
	['AD68', 'K97-K97/GT', '94'],
	['AD69', 'K115-U14', '207'],
	['AD70', 'K87-10', '207'],
	['AD71', 'K100-P10', '207'],
	['AD72', 'K115-K115/GT', '94'],
	['AD73', 'K87-K87/U14', '94'],
	['AD74', 'K100-05', '19'],
	['AD75', 'K104-K104/05', '90'],
	['AD76', 'K87-10', '19'],
	['AD77', 'K105-U12', '19'],
	['AD78', 'K25-K101/10', '94'],
	['AD79', 'K24-K24/05', '90'],
	['AD80', 'K115-U14', '19'],
	['AD81', 'K100-10', '19'],
	['AD82', 'K08-U13', '207'],
	['AD83', 'K116-107', '207'],
	['AD84', 'K57-P25', '401'],
	['AD85', 'K86-U14', '401'],
	['AD86', 'K115-10', '19'],
	['AD87', 'K117-20', '19'],
	['AD88', 'K86-77', '209'],
	['AD89', 'K52-P10', '209'],
	['AD90', 'K116-25', '209'],
	['AD91', 'K116-K116/PU12', '302'],
	['AD92', 'K115-PGT', '77'],
	['AD93', 'K120-K120/GT', '300'],
	['AD94', 'K103-K103/GT', '94'],
	['AD95', 'K117-05', '22'],
	['AD97', 'K137-P10', '411'],
	['AD98', 'K135-05', '411'],
	['AD99', 'K105-PGT', '411'],
	['AE01', 'K87-GT', '411'],
	['AE02', 'K116-U14', '402'],
	['AE03', 'K136-P10', '402'],
	['AE04', 'K117-05', '402'],
	['AE05', 'K108-05', '17'],
	['AE06', 'K115-GT', '17'],
	['AE07', 'K132-P10', '17'],
	['AE08', 'K134-P10', '17'],
	['AE09', 'K83-35', '17'],
	['AE10', 'K116-PU12', '17'],
	['AE11', 'K136-P10', '17'],
	['AE12', 'K133-GT', '17'],
	['AE13', 'K134-P10', '401'],
	['AE14', 'K115-PGT', '401'],
	['AE15', 'K114-115', '401'],
	['AE16', 'K133-U14', '401'],
	['AE17', 'K100-10', '22'],
	['AE18', 'K87-05', '22'],
	['AE19', 'K134-U9', '22'],
	['AE20', 'K76-10', '22'],
	['AE21', 'K134-P10', '402'],
	['AE22', 'K133-U14', '402'],
	['AE23', 'K131-05', '402'],
	['AE24', 'K105-GT', '402'],
	['AE25', 'K24-PU9', '19'],
	['AE26', 'K132-05', '19'],
	['AE27', 'K112-U14', '19'],
	['AE28', 'K112-PU9', '207'],
	['AE29', 'K87-GT', '207'],
	['AE30', 'K97-10', '207'],
	['AE31', 'K130-05', '207'],
	['AE32', 'K131-107', '402'],
	['AE33', 'K134-U9', '19'],
	['AE34', 'K100-10', '21'],
	['AE35', 'K132-05', '21'],
	['AE36', 'K133-P77', '17'],
	['AE37', 'K135-05', '01'],
	['AE38', 'K137-10', '01'],
	['AE39', 'K130-05', '01'],
	['AE40', 'K118-U14', '22'],
	['AE41', 'K114-05', '22'],
	['AE42', 'K130-05', '21'],
	['AE43', 'K116-U14', '207'],
	['AE44', 'K119-P10', '22'],
	['AE45', 'K115-U14', '22'],
	['AE46', 'K137-107', '22'],
	['AE48', 'K133-P10', '01'],
	['AE49', 'K45-05', '21'],
	['AE50', 'K115-PGT', '21'],
	['AE51', 'K85-U14', '21'],
	['AE52', 'K126-35', '17'],
	['AE53', 'K117-U14', '17'],
	['AE54', 'K115-K24/U14', '303'],
	['AE55', 'K85-K85/PGT', '303'],
	['AE56', 'K132-05', '01'],
	['AE57', 'K24-K24/05', '303'],
	['AE58', 'K110-K110/10', '303'],
	['AE59', 'K24-U9', '22'],
	['AE60', 'K25-10', '22'],
	['AE61', 'K130-05', '22'],
	['AE62', 'K100-10', '01'],
	['AE63', 'K87-10', '01'],
	['AE64', 'K111-10', '21'],
	['AE65', 'K115M-U14', '21'],
	['AE66', 'K138M-10', '22'],
	['AE67', 'K119M-K119M/P10', '94'],
	['AE68', 'K118-113', '01'],
	['AE69', 'K139-10', '402'],
	['AE70', 'K112-10', '207'],
	['AE71', 'K139M-10', '21'],
	['AE72', 'K24M-10', '19'],
	['AE73', 'K148-10', '19'],
	['AE74', 'K127-U13', '19'],
	['AE75', 'K138M-05', '19'],
	['AE76', 'K24M-PU12', '402'],
	['AE77', 'K143-U9', '402'],
	['AE78', 'K114-05', '402'],
	['AE79', 'K25-113', '402'],
	['AE80', 'K149-05', '401'],
	['AE81', 'K83-PU9', '401'],
	['AE82', 'K133-77', '401'],
	['AE83', 'K118-113', '401'],
	['AE84', 'K146-05', '401'],
	['AE85', 'K138-05', '401'],
	['AE86', 'K117-P10', '401'],
	['AE87', 'K115M-PU12', '402'],
	['AE88', 'K84-PU9', '402'],
	['AE89', 'K145-GT', '402'],
	['AE90', 'K111-K111/10', '90'],
	['AE91', 'K131-05', '19'],
	['AE92', 'K139M-U9', '19'],
	['AE93', 'K24M-05', '21'],
	['AE94', 'K111M-05', '19'],
	['AE95', 'K139-K157/U9', '91'],
	['AE96', 'K127-10', '01'],
	['AE97', 'K149-05', '17'],
	['AE98', 'K137-05/U38', '22'],
	['AE99', 'K114M-U14', '416'],
	['AF01', 'K138M-05', '416'],
	['AF02', 'K137-05/U38', '21'],
	['AF03', 'K25-PU12', '207'],
	['AF04', 'K23-PU12', '01'],
	['AF06', 'K25-PU9', '207'],
	['AF07', 'K115-K115/U14', '94'],
	['AF08', 'K145-K145/113', '307'],
	['AF09', 'K146-PU12', '209'],
	['AF10', 'K149-20', '209'],
	['AF11', 'K118-U14', '209'],
	['AF12', 'K133-05', '209'],
	['AF13', 'K134-U33', '209'],
	['AF14', 'K143-60', '209'],
	['AF15', 'K24M-PU12', '209'],
	['AF16', 'K83-K24/35', '306'],
	['AF17', 'K136-K136/P10', '306'],
	['AF18', 'K126-60', '210'],
	['AF19', 'K118-U14', '210'],
	['AF20', 'K87-K87/35', '306'],
	['AF21', 'K145-K145/P77', '306'],
	['AF22', 'K150-U9', '210'],
	['AF23', 'K143-PU12', '210'],
	['AF24', 'K24M-PU12', '413'],
	['AF25', 'K143-U14', '413'],
	['AF26', 'K133-05', '413'],
	['AF27', 'K134-U9', '413'],
	['AF28', 'K24M-U9', '206'],
	['AF29', 'K113-P10', '206'],
	['AF30', 'K132-K160/10', '305'],
	['AF31', 'K134-U9', '206'],
	['AF32', 'K139-PU9', '418'],
	['AF33', 'K24M-U9', '418'],
	['AF34', 'K113-K113/U13', '308'],
	['AF35', 'K101-K25/U9', '308'],
	['AF36', 'K24-U9', '21'],
	['AF37', 'K42-10', '21'],
	['AF38', 'K24-P10', '22'],
	['AF39', 'K115-GT', '19'],
	['AF40', 'K87-U14', '19'],
	['AF41', 'K119M-P10', '19'],
	['AF42', 'K24-K24/U9', '90'],
	['AF43', 'K92-U14', '402'],
	['AF44', 'K37-PGT', '402'],
	['AF45', 'K87-10', '17'],
	['AF46', 'K97-PGT', '17'],
	['AF47', 'K45-K24/05', '94'],
	['AF48', 'K119-P10', '17'],
	['AF49', 'K25-K25/10', '91'],
	['AF50', 'K24-K24/05', '301'],
	['AF51', 'K25-10', '19'],
	['AF52', 'K104-05', '19'],
	['AF53', 'K24-05', '19'],
	['AF54', 'K111-10', '19'],
	['AF55', 'K111M-U9', '01'],
	['AF56', 'K134-PU9', '01'],
	['AF57', 'K24M-10', '01'],
	['AF58', 'K127-U9', '01'],
	['AF59', 'K24M-U9', '01'],
	['AF60', 'K167M-U9', '22'],
	['AF61', 'K171M-U14', '21'],
	['AF62', 'K171-PU9', '01'],
	['AF63', 'K169-05', '01'],
	['AF64', 'K173-77', '01'],
	['AF65', 'K163-P10', '402'],
	['AF66', 'K133-P10', '402'],
	['AF67', 'K112M-U9', '21'],
	['AF68', 'K170M-05', '207'],
	['AF69', 'K24M-10', '207'],
	['AF70', 'K169M-05', '207'],
	['AF71', 'K25-K25/10', '301'],
	['AF72', 'K113M-K113M/10', '91'],
	['AF74', 'K174-10', '19'],
	['AF75', 'K170-U9', '19'],
	['AF76', 'K24M-U9', '207'],
	['AF77', 'K25-10', '207'],
	['AF78', 'K105-60', '401'],
	['AF79', 'K25M-10', '19'],
	['AF80', 'K163M-05', '209'],
	['AF81', 'K137-05/U38', '19'],
	['AF82', 'K143-U9', '210'],
	['AF83', 'K24M-PU12', '210'],
	['AF84', 'K172-U9', '210'],
	['AF85', 'K139-K157/05', '306'],
	['AF86', 'K171-P60', '209'],
	['AF87', 'K145M-PU9', '209'],
	['AF88', 'K172-05/U33', '209'],
	['AF89', 'K24M-05/U38', '209'],
	['AF90', 'K24M-K24M/U9', '306'],
	['AF91', 'K165-PU12', '210'],
	['AF92', 'K134-P10', '210'],
	['AF93', 'K115-U14', '210'],
	['AF94', 'K107M-PU9', '210'],
	['AF95', 'K24-K24/GT', '306'],
	['AF96', 'K127-PU12', '210'],
	['AF97', 'K163-P10', '210'],
	['AF98', 'K112-U9', '219'],
	['AF99', 'K24M-K24M/10', '305'],
	['AG01', 'K169-K168/P10', '305'],
	['AG02', 'K25-K25/10', '305'],
	['AG03', 'K104M-K104M/05', '305'],
	['AG04', 'K170-U9', '206'],
	['AG05', 'K137-PU12', '207'],
	['AG06', 'K24M-K24M/U9', '304'],
	['AG07', 'K25-10', '207'],
	['AG08', 'K139-05', '207'],
	['AG09', 'K24-10', '207'],
	['AG10', 'K132-05', '207'],
	['AG11', 'K112-U9', '207'],
	['AG12', 'K115-U13', '207'],
	['AG13', 'K117-05', '219'],
	['AG14', 'K24-PU9', '417'],
	['AG15', 'K143M-PU9', '417'],
	['AG16', 'K24M-K24M/U9', '309'],
	['AG17', 'K130-U9/U38', '420'],
	['AG18', 'K127-K127/U9', '309'],
	['AG19', 'K137-107', '210'],
	['AG20', 'K24M-10', '22'],
	['AG21', 'K24M-U9', '21'],
	['AG22', 'K117M-PU9', '417'],
	['AG23', 'K171M-05/U33', '21'],
	['AG24', 'K133-10', '207'],
	['AG25', 'K127-U9', '207'],
	['AG26', 'K127-10', '207'],
	['AG27', 'K122-U14', '210'],
	['AG28', 'K45-05/U38', '210'],
	['AG29', 'K133-U14', '210'],
	['AG30', 'K143-U12', '210'],
	['AG31', 'K179-GT', '210'],
	['AG32', 'K171-PU9', '210'],
	['AG33', 'K165-P10', '210'],
	['AG34', 'K171-K171/PU12', '307'],
	['AG35', 'K182-PU9', '209'],
	['AG36', 'K133-77', '209'],
	['AG37', 'K143-U12', '209'],
	['AG38', 'K137-05/PU9', '210'],
	['AG39', 'K143M-U12', '210'],
	['AG40', 'K87-PU12', '210'],
	['AG41', 'K163-P10', '209'],
	['AG42', 'K179-PU12', '209'],
	['AG43', 'K24-K24/PU9', '313'],
	['AG44', 'K24M-K24M/10', '311'],
	['AG45', 'K139-05/PU9', '206'],
	['AG46', 'K174-10', '206'],
	['AG47', 'K127-10', '206'],
	['AG48', 'K170M-10', '207'],
	['AG49', 'K109-U9', '207'],
	['AG50', 'K178M-K24M/05', '312'],
	['AG51', 'K182-K25/U9', '312'],
	['AG52', 'K182M-U9', '207'],
	['AG53', 'K178M-05', '207'],
	['AG54', 'K127M-K127M/U9', '311'],
	['AG55', 'K176-U14', '21'],
	['AG56', 'K178M-05', '21'],
	['AG57', 'K163-K164/P10', '94'],
	['AG58', 'K24M-K24M/10', '90'],
	['AG59', 'K122M-U14', '209'],
	['AG60', 'K165-P10', '209'],
	['AG61', 'K134-05', '01'],
	['AG62', 'K45-05/PU9', '01'],
	['AG63', 'K171-K171/U14', '94'],
	['AG64', 'K133-05', '210'],
	['AG65', 'K139M-10', '207'],
	['AG66', 'K177M-10', '207'],
	['AG67', 'K170M-U9', '207'],
	['AG68', 'K182M-U9', '21'],
	['AG69', 'K183-10', '207'],
	['AG70', 'K171M-PU12', '401'],
	['AG71', 'K182M-U9', '19'],
	['AG72', 'K167-10', '209'],
	['AG73', 'K173-P60', '209'],
	['AG74', 'K182-K25/10', '311'],
	['AG75', 'K87-K87/P60', '306'],
	['AG76', 'K177-PU12', '210'],
	['AG77', 'K121-PU12', '420'],
	['AG78', 'K87-K87/P60', '300'],
	['AG79', 'K85-U12', '22'],
	['AG80', 'K178M-U9', '402'],
	['AG81', 'K87M-GT', '416'],
	['AG82', 'K143-PU9', '402'],
	['AG83', 'K104M-U9', '416'],
	['AG84', 'K25M-10', '21'],
	['AG85', 'K198-PU12', '210'],
	['AG86', 'K133-77', '210'],
	['AG87', 'K121-PU12', '210'],
	['AG88', 'K163-05/U33', '210'],
	['AG89', 'K198-10', '219'],
	['AG90', 'K196M-U9', '219'],
	['AG91', 'K201-10', '206'],
	['AG92', 'K45-05/U38', '209'],
	['AG93', 'K201-P60', '210'],
	['AG94', 'K198-05/U38', '210'],
	['AG95', 'K171-PU12', '210'],
	['AG96', 'K134-PU9', '210'],
	['AG97', 'K24M-P10', '209'],
	['AG98', 'K178-05/U38', '209'],
	['AG99', 'K170-10', '207'],
	['AH01', 'K179-U12', '209'],
	['AH02', 'K202-P60', '209'],
	['AH03', 'K198-10', '207'],
	['AH04', 'K199-05/U38', '416'],
	['AH05', 'K175-PU9', '206'],
	['AH06', 'K169-10', '207'],
	['AH07', 'K174-U9', '207'],
	['AH08', 'K196M-U9', '206'],
	['AH09', 'K200-10', '206'],
	['AH10', 'K139-05', '206'],
	['AH11', 'K208-05/U38', '209'],
	['AH12', 'K143-PU12', '209'],
	['AH13', 'K173-77', '209'],
	['AH14', 'K25-10', '206'],
	['AH15', 'K139-U9', '206'],
	['AH16', 'K164-PU9', '206'],
	['AH17', 'K115-U14', '207'],
	['AH18', 'K24M-PU9', '207'],
	['AH19', 'K137-U34', '207'],
	['AH20', 'K119-P10', '207'],
	['AH21', 'K24M-05', '207'],
	['AH22', 'K204M-PU9', '19'],
	['AH23', 'K202-60', '210'],
	['AH24', 'K208-U14', '210'],
	['AH25', 'K204M-05/U38', '207'],
	['AH26', 'K24M-U9', '19'],
	['AH27', 'K170-05/U9', '206'],
	['AH28', 'K177-10', '206'],
	['AH29', 'K204-PU9', '206'],
	['AH30', 'K24-U9', '219'],
	['AH31', 'K85-PU9', '219'],
	['AH32', 'K139M-05', '219'],
	['AH33', 'K176-PU9', '219'],
	['AH34', 'K24M-K24M/PU9', '306'],
	['AH35', 'K173-75', '210'],
	['AH36', 'K202-P60', '210'],
	['AH37', 'K24M-U9/U38', '207'],
	['AH38', 'K134-P10', '207'],
	['AH39', 'K204-PU9', '207'],
	['AH40', 'K170-PU9', '207'],
	['AH41', 'K24-PU9', '207'],
	['AH42', 'K25M-10', '207'],
	['AH43', 'K178M-U9', '207'],
	['AH44', 'K87-U12', '207'],
	['AH45', 'K200-10', '19'],
	['AH46', 'K201-PU9', '207'],
	['AH47', 'K177M-10', '207'],
	['AH48', 'K184-U9', '207'],
	['AH49', 'K24M-U9', '207'],
	['AH50', 'K204-GT', '207'],
	['AH51', 'K200-P10', '207'],
	['AH52', 'K150-05', '207'],
	['AH53', 'K24-PU9', '22'],
	['AH54', 'K204-U13', '206'],
	['AH55', 'K25M-10', '206'],
	['AH56', 'K201M-U9', '207'],
	['AH57', 'K211-10', '207'],
	['AH58', 'K178-05', '207'],
	['AH59', 'K137-U9', '207'],
	['AH60', 'K213-PU9', '207'],
	['AH61', 'K24-PGT', '421'],
	['AH62', 'K212-P60', '421'],
	['AH63', 'K173-P77', '421'],
	['AH64', 'K163-P10', '421'],
	['AH65', 'K45-U38', '209'],
	['AH66', 'K145-GT', '209'],
	['AH67', 'K202-60', '209'],
	['AH68', 'K213-10', '206'],
	['AH69', 'K25M-U13', '206'],
	['AH70', 'K24-U9', '206'],
	['AH71', 'K132M-05', '206'],
	['AH72', 'K217-10', '207'],
	['AH73', 'K201M-U9', '207'],
	['AH74', 'K199-P10', '207'],
	['AH75', 'K214-U14', '209'],
	['AH76', 'K145M-P10', '207'],
	['AH77', 'K209-P10', '209'],
	['AH78', 'K137-PU9', '209'],
	['AH79', 'K24-U9', '207'],
	['AH80', 'K115M-U14', '207'],
	['AH81', 'K163-PU9', '207'],
	['AH82', 'K24M-PU9', '209'],
	['AH83', 'K213-PU12', '209'],
	['AH84', 'K209-GT', '209'],
	['AH85', 'K164-U9', '206'],
	['AH86', 'K131-10', '206'],
	['AH87', 'K214-U9', '19'],
	['AH88', 'K217-U38', '207'],
	['AH89', 'K175M-U9', '206'],
	['AH90', 'K204-10', '206'],
	['AH91', 'K218-U14', '209'],
	['AH92', 'K204-PU12', '209'],
	['AH93', 'K24-PGT', '207'],
	['AH94', 'K209-U14', '207'],
	['AH95', 'K163-P10', '207'],
	['AH96', 'K24-GT', '207'],
	['AH97', 'K24M-PU12', '207'],
	['AH98', 'K216-K216/U14', '306'],
	['AH99', 'K237-U9', '206'],
	['AI01', 'K195-U9', '207'],
	['AI02', 'K199-U12', '209'],
	['AI03', 'K223-U9/K204', '311'],
	['AI04', 'K227-U33', '207'],
	['AI05', 'K231-109', '207'],
	['AI06', 'K237-10', '207'],
	['AI07', 'K225M-109', '207'],
	['AI08', 'K150-U38', '207'],
	['AI09', 'K208-127', '207'],
	['AI10', 'K157-PU9', '207'],
	['AI11', 'K217-107', '206'],
	['AI12', 'K199-PU12', '206'],
	['AI13', 'K250-U9', '207'],
	['AI14', 'K201M-10', '207'],
	['AI15', 'K227-PU9', '207'],
	['AI16', 'K237-U9', '207'],
	['AI17', 'K228-10', '206'],
	['AI18', 'K24-P10', '207'],
	['AI19', 'K261-U9', '207'],
	['AI20', 'K223-P10', '207'],
	['AI21', 'K237-05/U38', '207'],
	['AI22', 'K232-PU9', '207'],
	['AI23', 'K25-U38', '207'],
	['AI24', 'K115-60', '207'],
	['AI25', 'K225M-U9', '207'],
	['AI26', 'K232-PU9', '207'],
	['AI27', 'K223-U16', '207'],
	['AI28', 'K260-PU14', '207'],
	['AI29', 'K195-P10', '207'],
	['AI30', 'K265-PU9', '207'],
	['AI31', 'K256-10', '207'],
	['AI32', 'K265-P10', '207'],
	['AI33', 'K258-PU14', '209'],
	['AI34', 'K115-PU15', '209'],
	['AI35', 'K223-PU14', '207'],
	['AI36', 'K265-10', '207'],
	['AI37', 'K160-10', '207'],
	['AI38', 'K199M-10', '207'],
	['AI39', 'K251-10', '207'],
	['AI40', 'K25-GT', '207'],
	['AI41', 'K24M-GT', '206'],
	['AI42', 'K201-PU9', '206'],
	['AI43', 'K256-10', '206'],
	['AI44', 'K237-U16', '206'],
	['AI45', 'K209-PU14', '209'],
	['AI46', 'K204-U15', '209'],
	['AI47', 'K258-PU12', '209'],
	['AI48', 'K223-PU9', '209'],
	['AI49', 'K227-U9', '206'],
	['AI50', 'K265-10', '219'],
	['AI51', 'K227-PU9', '219'],
	['AI52', 'K234-U9', '206'],
	['AI53', 'K269-10', '206'],
	['AI54', 'K199M-P10', '207'],
	['AI55', 'K237-U16', '207'],
	['AI56', 'K160-PU16', '207'],
	['AI57', 'K270-U15', '207'],
	['AI58', 'K272-U38', '207'],
	['AI59', 'K252-PU14', '209'],
	['AI60', 'K269-PU9', '209'],
	['AI61', 'K204-GT', '209'],
	['AI62', 'K237-U16', '209'],
	['AI63', 'K208-P10', '209'],
	['AI64', 'K222-P10', '207'],
	['AI65', 'K272-P10', '207'],
	['AI66', 'K259-U16', '206'],
	['AI67', 'K196-10', '207'],
	['AI68', 'K204-U16', '207'],
	['AI69', 'K258-PU15', '209'],
	['AI70', 'K237-10', '206'],
	['AI71', 'K175-GT', '209'],
	['AI72', 'K115-PU16', '206'],
	['AI73', 'K175-GT', '206'],
	['AI74', 'K254-U9', '206'],
	['AI75', 'K254-K199/U9', '311'],
	['AI76', 'K265-10', '206'],
	['AI77', 'K24M-P10', '219'],
	['AI78', 'K256-10', '219'],
	['AI79', 'K256-K256/10', '311'],
	['AI80', 'K237-U16', '219'],
	['AI81', 'K223-PU12', '219'],
	['AI82', 'K199-P10', '219'],
	['AI83', 'K199-K199/P10', '311'],
	['AI84', 'K271-U9', '219'],
	['AI85', 'K24-K24/PU9', '312'],
	['AI86', 'K24-PU9', '207'],
	['AI87', 'K117-U16', '207'],
	['AI88', 'K260-U9', '207'],
	['AI89', 'K277-10', '219'],
	['AI90', 'K115-PU15', '206'],
	['AI91', 'K270-PU15', '209'],
	['AI92', 'K115-PU15', '215'],
	['AI93', 'K199-P10', '209'],
	['AI94', 'K209-75', '209'],
	['AI95', 'K223-PU9', '209'],
	['AI96', 'K248-U15', '209'],
	['AI97', 'K162M-K162M/10', '311'],
	['AI98', 'K270-U12', '206'],
	['AI99', 'K251-10', '219'],
	['AJ01', 'K143-PU14', '207'],
	['AJ02', 'K204-PU12', '207'],
	['AJ03', 'K230-PU14', '209'],
	['AJ04', 'K24M-GT', '209'],
	['AJ05', 'K24-P10', '209'],
	['AJ06', 'K201-U9', '207'],
	['AJ07', 'K231-U9', '207'],
	['AJ08', 'K24M-P10', '207'],
	['AJ09', 'K228-U9', '207'],
	['AK01', 'K204-U9', '207'],
	['AK02', 'K218-PU14', '210'],
	['AK03', 'K216-P10', '210'],
	['AK04', 'K199-PU12', '210'],
	['AK05', 'K237-10', '219'],
	['AK06', 'K234-U9', '219'],
	['AK07', 'K257-10', '219'],
	['AK08', 'K228-PU9', '207'],
	['AK09', 'K250-10', '207'],
	['AK10', 'K115-U9', '206'],
	['AK11', 'K271-10', '206'],
	['AK12', 'K117-U16', '206'],
	['AK13', 'K256-U9', '206'],
	['AK14', 'K271-U13', '206'],
	['AK15', 'K143-P10', '209'],
	['AK16', 'K157-10', '209'],
	['AK17', 'K223-PU9', '207'],
	['AK18', 'K24-GT', '207'],
	['AK19', 'K199-PU15', '209'],
	['AK20', 'K214-PU14', '209'],
	['AK21', 'K137-PU9', '207'],
	['AK22', 'K272-U38', '207'],
	['AK23', 'K196-10', '206'],
	['AK24', 'K24-P10', '206'],
	['AK25', 'K251-PU9', '206'],
	['AK26', 'K223-05', '219'],
	['AK27', 'K24-P10', '215'],
	['AK28', 'K237-10', '215'],
	['AK29', 'K223-PU9', '215'],
	['AK30', 'K204-109', '215'],
	['AK31', 'K199-PU9', '219'],
	['AK32', 'K175-P10', '219'],
	['AK33', 'K196-U9', '207'],
	['AK34', 'K175-U9', '206'],
	['AK35', 'K266-P70', '219'],
	['AK36', 'K223-PU9', '219'],
	['AK37', 'K265-P10', '207'],
	['AK38', 'K162M-107', '207'],
	['AK39', 'K226-P70', '207'],
	['AK40', 'K223-U9', '207'],
	['AK41', 'K201-U9', '219'],
	['AK42', 'K237-U13', '219'],
	['AK43', 'K271-10', '209'],
	['AK44', 'K24-U9', '207'],
	['AK45', 'K25-10', '207'],
	['AK46', 'K258-PU9', '207'],
	['AK47', 'K24-U38', '209'],
	['AK48', 'K204-PU15', '209'],
	['AK49', 'K209-P10', '209'],
	['AK50', 'K25-U9', '206'],
	['AK51', 'K237-PU16', '206'],
	['AK52', 'K25-P10', '207'],
	['AK53', 'K175-10', '207'],
	['AK54', 'K204-PU9', '207'],
	['AK55', 'K24-PU9', '219'],
	['AK56', 'K25-10', '219'],
	['AK57', 'K25M-PU9', '207'],
	['AK58', 'K258-P10', '209'],
	['AK59', 'K237-U16', '207'],
	['AK60', 'K259-U9', '207'],
	['AK61', 'K26-PGT', '209'],
	['AK62', 'K24-U9', '219'],
	['AK63', 'K209-GT', '215'],
	['AK64', 'K115-PU14', '209'],
	['AK65', 'K199-GT', '209'],
	['AK66', 'K256-GT', '207'],
	['AK67', 'K199-PU15', '207'],
	['AK68', 'K223-PU9', '207'],
	['AK69', 'K204-10', '207'],
	['AK70', 'K24M-PU9', '207'],
	['AK71', 'K265-U9', '207'],
	['AK72', 'K204-GT', '207'],
	['AK73', 'K115M-10', '207'],
	['AK74', 'K162M-10', '219'],
	['AK75', 'K251-U9', '219'],
	['AK76', 'K248-10', '207'],
	['AK77', 'K201-U9', '206'],
	['AK78', 'K24M-PU9', '206'],
	['AK79', 'K25-10', '206'],
	['AK80', 'K265-P10', '219'],
	['AK81', 'K24-GT', '219'],
	['AK81', 'K24-GT', '219'],
	['AK82', 'K248-PU14', '219'],
	['AK83', 'K272-P10', '219'],
	['AK84', 'K26-U9', '206'],
	['AK85', 'K26-U9', '207'],
	['AK86', 'K24-P10', '207'],
	['AK87', 'K199-PU15', '210'],
	['AK88', 'K208-GT', '210'],
	['AK89', 'K214-P10', '210'],
	['AK90', 'K265-PU9', '207'],
	['AK91', 'K223-PU14', '210'],
	['AK92', 'K24M-P10', '207'],
	['AK93', 'K256-10', '207'],
	['AK94', 'K24M-U9', '207'],
	['AK95', 'K137-U38', '207'],
	['AK96', 'K107-U9', '207'],
	['AK97', 'K162M-PU9', '207'],
	['AK98', 'K223-GT', '207'],
	['AK99', 'K171-P10', '207'],
	['AL01', 'K24-10', '207'],
	['AL02', 'K223-U12', '209'],
	['AL03', 'K204-PU14', '209'],
	['AL04', 'K204-10', '206'],
	['AL05', 'K115-U9', '206'],
	['AL06', 'K137-PU9', '209'],
	['AL07', 'K162-PU12', '209'],
	['AL08', 'K223-U16', '219'],
	['AL09', 'K237-U9', '219'],
	['AL10', 'K285-10', '219'],
	['AL11', 'K24M-U9', '206'],
	['AL12', 'K223-PU9', '206'],
	['AL13', 'K283-U9', '206'],
	['AL14', 'K199-05/U38', '209'],
	['AL15', 'K284-PU15', '209'],
	['AL16', 'K181-U13', '207'],
	['AL17', 'K199-U38', '208'],
	['AL18', 'K284-PU15', '208'],
	['AL19', 'K137-PU9', '208'],
	['AL20', 'K258-P10', '208'],
	['AL21', 'K282-P10', '219'],
	['AL22', 'K284-PGT', '219'],
	['AL23', 'K24-PGT', '219'],
	['AL24', 'K286-10', '219'],
	['AL25', 'K289-P10', '219'],
	['AL26', 'K288-GT', '219'],
	['AL27', 'K290-U16', '219'],
	['AL28', 'K285-GT', '207'],
	['AL29', 'K282-PU9', '207'],
	['AL30', 'K287-P10', '207'],
	['AL31', 'K282-U9', '207'],
	['AL32', 'K284-U15', '207'],
	['AL33', 'K289-PU14', '207'],
	['AL34', 'K284-P10', '207'],
	['AL35', 'K24-10', '219'],
	['AL36', 'K288-PU9', '219'],
	['AL37', 'K260-GT', '219'],
	['AL38', 'K284-GT', '215'],
	['AL39', 'K282-P10', '215'],
	['AL40', 'K24-PU9', '215'],
	['AL41', 'K289-PU14', '209'],
	['AL42', 'K281-PU9', '207'],
	['AL43', 'K283-U9', '207'],
	['AL44', 'K177-P10', '207'],
	['AL45', 'K289-U9', '207'],
	['SC89', 'K223-U16'],
	['SC90', 'K226-U9'],
	['SC91', 'K256-10'],
	['SC105', 'K175-10']
].map(([code, color, temple]) => ({ code, color, temple }))
